/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';

import {
  HeadingContainer, StatsGraphHeading, NoResultsHeading, LoadingSpinner,
} from '../Styles';
import DateFilterDropdown from '../DateFilterDropdown';
import PieChartGraph from '../PieChart';

import useStrings from '../../../../hooks/useStrings';
import { useGetTopEventTypes } from '../../../../lib/graphql/queries';
import { fromDate } from '../../../../lib/Utils';

const TopEventTypes: React.FC<TopEventTypesProps> = () => {
  const [{ Statistics: strings }] = useStrings();

  const [showDateFilter, setShowDateFilter] = useState(false);
  const [filterSelected, setFilterSelected] = useState<'week' | 'month' | 'year'>('week');

  const { data: topEventTypesData, loading } = useGetTopEventTypes({
    variables: { fromDate: fromDate(filterSelected) },
  });
  const topEventTypes = topEventTypesData?.topEventTypes.types?.map((type) => (
    {
      name: type.type,
      value: type.count,
    }
  )) || [];

  return (
    <>
      <HeadingContainer>
        <StatsGraphHeading>{strings.topEventType}</StatsGraphHeading>
        <DateFilterDropdown
          onToggleDropdown={() => setShowDateFilter(!showDateFilter)}
          isDropdownShown={showDateFilter}
          onClickFilter={setFilterSelected}
          filterSelected={filterSelected}
        />
      </HeadingContainer>
      {loading
        ? <LoadingSpinner />
        : topEventTypes.length === 0
          ? <NoResultsHeading>{strings.noResults}</NoResultsHeading>
          : <PieChartGraph data={topEventTypes} />}
    </>
  );
};

interface TopEventTypesProps { }

export default TopEventTypes;
